/* CookSVG — motion layer. No dependencies. */
(function () {
  'use strict';
  if (window.__ckMotion) return;
  window.__ckMotion = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function markReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('ck-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    var sections = document.querySelectorAll('.shopify-section, [id^="cook-"], [id^="cs-"]');
    Array.prototype.forEach.call(sections, function (el) {
      if (el.dataset.ckReveal) return;
      if (el.getBoundingClientRect().top < window.innerHeight * 0.86) return;
      el.dataset.ckReveal = '1';
      el.classList.add('ck-reveal');
      io.observe(el);
    });

    var grids = document.querySelectorAll('.product-grid, [class*="ck-grid"], [class*="cs-grid"], .ck-tiles');
    Array.prototype.forEach.call(grids, function (g) {
      if (g.dataset.ckStagger) return;
      if (g.getBoundingClientRect().top < window.innerHeight * 0.86) return;
      g.dataset.ckStagger = '1';
      g.classList.remove('ck-reveal');
      g.classList.add('ck-stagger');
      Array.prototype.slice.call(g.children, 0, 14).forEach(function (c, i) {
        c.style.setProperty('--ck-i', i);
      });
      io.observe(g);
    });
  }

  function stickyHeader() {
    var header = document.querySelector('[id^="cook-header"]') ||
                 document.querySelector('.section-header') ||
                 document.querySelector('sticky-header');
    if (!header || reduced) return;

    header.classList.add('ck-sticky');
    var last = window.scrollY, frame = false;

    window.addEventListener('scroll', function () {
      if (frame) return;
      frame = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        header.classList.toggle('ck-lifted', y > 12);
        var openMenu = header.querySelector('details[open], [aria-expanded="true"]');
        if (!openMenu && y > 320 && y > last + 6) header.classList.add('ck-hidden');
        else if (y < last - 6 || y < 320) header.classList.remove('ck-hidden');
        last = y;
        frame = false;
      });
    }, { passive: true });
  }

  function bumpBadge() {
    if (reduced) return;
    var badge = document.querySelector('.cart-count-bubble, [class*="ck-cart-count"], [data-cart-count]');
    if (!badge) return;
    badge.classList.remove('ck-bump');
    void badge.offsetWidth;
    badge.classList.add('ck-bump');
  }

  function cartFeedback() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.quick-add__submit, .cs-add, .product-form__submit, [name="add"]');
      if (!btn || btn.dataset.ckBusy) return;

      var original = btn.innerHTML;
      btn.dataset.ckBusy = '1';

      setTimeout(function () {
        btn.classList.add('ck-added');
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-3px"><path d="m5 13 4 4L19 7"/></svg> Added';
        bumpBadge();
      }, 380);

      setTimeout(function () {
        btn.classList.remove('ck-added');
        btn.innerHTML = original;
        delete btn.dataset.ckBusy;
      }, 1750);
    }, true);
  }

  document.addEventListener('cart:refresh', bumpBadge);
  document.addEventListener('cart:updated', bumpBadge);

  function fadeImages() {
    if (reduced) return;
    var imgs = document.querySelectorAll('.card__media img, .card__inner .media img, div[id^="cs-"] .cs-media img');
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.dataset.ckFade) return;
      img.dataset.ckFade = '1';
      img.classList.add('ck-fade');
      if (img.complete && img.naturalWidth) img.classList.add('ck-loaded');
      else {
        img.addEventListener('load', function () { img.classList.add('ck-loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('ck-loaded'); }, { once: true });
      }
    });
  }

  function tiles() {
    var nodes = document.querySelectorAll('[id^="cook-cat"] a, .cook-category-icons a');
    Array.prototype.forEach.call(nodes, function (a) { a.classList.add('ck-tile'); });
  }

  function backToTop() {
    if (reduced || document.getElementById('ck-top')) return;
    var b = document.createElement('button');
    b.id = 'ck-top';
    b.type = 'button';
    b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.appendChild(b);

    var frame = false;
    window.addEventListener('scroll', function () {
      if (frame) return;
      frame = true;
      requestAnimationFrame(function () {
        b.classList.toggle('ck-on', window.scrollY > 640);
        frame = false;
      });
    }, { passive: true });
  }

  function boot() {
    markReveal(); fadeImages(); tiles(); stickyHeader(); cartFeedback(); backToTop();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function () {
    markReveal(); fadeImages(); tiles();
  });

  if ('MutationObserver' in window) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { markReveal(); fadeImages(); }, 220);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
